export const StorageConst = {
  PHONE_RECOVERY_VALUE: 'PHONE_RECOVERY_VALUE'
}
